import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 8,
  },
  sectionTitle: {
    ...theme.fonts.h4,
  },
}));

interface Props {
  title?: string;
  children: React.ReactNode;
}

export const SessionFormSectionSubsection: React.FC<Props> = ({
  title,
  children,
}) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <div className={classes.container}>
      {title && <h2 className={classes.sectionTitle}>{title}</h2>}
      {children}
    </div>
  );
};
